"use client";
import React from "react";
import { ButtonPrimary } from "@/components/common/ButtonPrimary";
import { ButtonOutline } from "@/components/common/ButtonOutline";

interface PageActionsProps {
  onContinue: () => void;
  onBack: () => void;
  continueDisabled: boolean;
  continueText: string;
  backText: string;
}

export const PageActions: React.FC<PageActionsProps> = ({
  onContinue,
  onBack,
  continueDisabled,
  continueText,
  backText,
}) => {
  return (
    <div
      className="sticky bottom-0 left-0 right-0 flex space-x-4 mt-8 pt-6 pb-6 bg-background/70 dark:bg-background/70 border-t border-border/40 backdrop-blur-sm animate-fadeInUp z-50"
      style={{ animationDelay: "0.3s" }}
    >
      <div className="max-w-4xl mx-auto px-8 w-full flex space-x-4">
        <ButtonPrimary
          onClick={onContinue}
          disabled={continueDisabled}
          className="flex-1"
        >
          {continueText}
        </ButtonPrimary>
        <ButtonOutline onClick={onBack}>{backText}</ButtonOutline>
      </div>
    </div>
  );
};
